/*IE 10 Mobil Phone Compatibility*/
// Copyright 2014-2015 Twitter, Inc.
// Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
  var msViewportStyle = document.createElement('style')
  msViewportStyle.appendChild(
    document.createTextNode(
      '@-ms-viewport{width:auto!important}'
    )
  )
  document.querySelector('head').appendChild(msViewportStyle)
}

$(document).ready(function() { 
  
  /* Utilities */
  /* Swipe Boostrap Carousels */
    $('.carousel').on('swipeleft', function(event) { 
        $('.carousel').carousel('next');
    }); 
    $('.carousel').on('swiperight', function(event) { 
        $('.carousel').carousel('prev');
    });  
  
    $(window).on('load', function() {
      // Set responsive images
      $('.rte img').css({'max-width':'100%','height':'auto'});

    });

    $('.rte iframe').wrap('<div class="embed-responsive embed-responsive-16by9"></div>').addClass('embed-responsive-item');  
  
  /* BS PopOver Init*/
  $(function () {
      $('[data-toggle="popover"]').popover();
  })

  
  /* Scroll To Top */
  if ($('#topMe').length) {
      var scrollTrigger = 100, // px
          backToTop = function () {
              var scrollTop = $(window).scrollTop();
              if (scrollTop > scrollTrigger) {
                  $('#topMe').addClass('show');
              } else {
                  $('#topMe').removeClass('show');
              }
          };
      backToTop();
      $(window).on('scroll', function () {
          backToTop();
      });
      $('#topMe').on('click', function (e) {
          e.preventDefault();
          $('html,body').animate({
              scrollTop: 0
          }, 700);
      });
  } 
  
  
  /*Hide form feedbacks after delay */
 $('.form-feedback').fadeIn(800).delay(2000).fadeOut(800);
  


/* Scroll Events */


  $(window).scroll(function(e) {
      var windowScroll = $(window).scrollTop();
    
      if(windowScroll < 110){
      }
      else  {
          
      }
  }); 

});

